import {connect} from 'react-redux';
import {Resources} from './Resources.js';
import {fetchDataWithRedux} from "../../redux/actions/action-creators";

const mapStateToProps = (state) => {
    // console.log(state);
    return {
        data: state.wikiResources.data,
        isLoaded: true
    }
}


const ResourcesContainer = connect(
    mapStateToProps,
    {fetchDataWithRedux}
)(Resources);

export default ResourcesContainer;




// WEBPACK FOOTER //
// ./src/components/Resources/ResourcesContainer.js